import * as React from 'react';

import { Typography } from '@spotnana/blocks/src/Typography';
import { Button } from '@spotnana/blocks/src/Button';
import { flex } from '@spotnana/blocks/src/utils';
import { Container } from '@spotnana/blocks/src/Container';
import { AirSelectedItineraryResponseManager, ITraveler, useHasUserAccess, userRolesByFeature } from 'obt-common';
import {
  back_button,
  checkout_page_container,
  checkout_title_container,
  checkout_content_container,
  checkout_content_background,
  title_accessory,
} from './styles';
import { AddToShareItineraryListModalContainer } from '../AddToShareItineraryListModalContainer';
import { useIsFareQuoteThirdPartySourceEnabled } from '../../SavedFaresPage/hooks/useIsFareQuoteThirdPartySourceEnabled';

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  title: string;
  titleAccessoryView?: React.ReactNode;
  backButtonText: string;
  onBack: () => void;
  shouldShowAddToItineraryList: boolean;
  airSelectedItineraryResponseManager: AirSelectedItineraryResponseManager | null;
  itineraryOwner: ITraveler | null;
}

function CheckoutContainer({
  children,
  title,
  titleAccessoryView,
  backButtonText,
  onBack,
  shouldShowAddToItineraryList,
  airSelectedItineraryResponseManager,
  itineraryOwner,
  ...rest
}: IProps): JSX.Element {
  const hasArrangerAndAboveAccess = useHasUserAccess(userRolesByFeature.travelerArrangerAndAbove);

  const isThirdPartySourceEnabled = useIsFareQuoteThirdPartySourceEnabled(airSelectedItineraryResponseManager);

  const renderAddToShareList =
    shouldShowAddToItineraryList &&
    airSelectedItineraryResponseManager &&
    itineraryOwner &&
    hasArrangerAndAboveAccess &&
    isThirdPartySourceEnabled;

  return (
    <div css={checkout_page_container} data-testid="checkout-booking-page-summary" {...rest}>
      <Container maxWidth="large" css={checkout_title_container}>
        <Button
          variant="ghost"
          size="small"
          onClick={onBack}
          data-testid="back-to-previous-page-text"
          css={back_button}
        >
          {backButtonText}
        </Button>

        <div css={[flex.init, flex.align.center]} data-testid="checkout-title">
          <Typography variant="header1">{title}</Typography>
          <div css={title_accessory}>{titleAccessoryView}</div>
          {renderAddToShareList && (
            <AddToShareItineraryListModalContainer
              airSelectedItineraryResponseManager={airSelectedItineraryResponseManager}
              itineraryOwner={itineraryOwner}
            />
          )}
        </div>
      </Container>

      <div css={checkout_content_background}>
        <Container maxWidth="large" css={checkout_content_container}>
          {children}
        </Container>
      </div>
    </div>
  );
}

export { LeftSection, RightSection } from './Sections';
export default CheckoutContainer;
